import { PureComponent } from "react";
import colors from "styles/colors";

import { componentStyles } from "./hotdog-header-component.scss";

export default class HotdogHeaderComponent extends PureComponent {
  render() {
    const { className, backgroundColor, containerHeight, containerMinHeight, hotdogColor, children } = this.props;

    return (
      <div
        className={`hotdog-header-component ${className}`}
        style={{ height: containerHeight, minHeight: containerMinHeight, backgroundColor: colors[backgroundColor] }}
      >
        <div className="hotdog" style={{ backgroundColor: colors[hotdogColor] }} />

        <div className="children-wrapper">{children}</div>

        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

HotdogHeaderComponent.defaultProps = {
  containerHeight: "48vh"
};
